import request from '../utils/request';
// post请求
export function postAction(url,data) {
   return request({
       url: url,
       method: 'post',
       data,
   });
}
// get请求
export function getAction(url,params) {
   return request({
       url: url,
       method: 'get',
       params,
   });
}

// 获取验证码
export function getCaptcha() {
   return request({
       url: '/appFront/captchaImage',
       method: 'get',
       responseType: 'blob' // 重要：设置响应类型为blob以接收图片数据
   });
}

// 登录接口
export function login(data) {
   return postAction('/appFront/pcLogin', data);
}

// 获取用户信息
export function getInfo(token) {
   return request({
       url: '/api/center/getUserInfo',
       method: 'get',
       params: { token }
   });
}



// 获取个人信息
export function getCurrUserInfo() {
   return getAction('/api/center/getUserInfo');
}

// ==================== 推广合伙人（分佣体系） ====================

// 合伙人信息（登录后先调，判断是否显示合伙人菜单）
export function getAgentInfo() {
   return getAction('/api/center/agentInfo');
}

// 创建下级账号
export function createSubordinate(data) {
   return postAction('/api/center/createSubordinate', data);
}

// 设置下级分成比例
export function setSubordinateRatio(data) {
   return postAction('/api/center/setSubordinateRatio', data);
}

// 下级列表
export function getAgentSubordinateList(params) {
   return getAction('/api/center/agentSubordinateList', params);
}